import { render } from "./passwordUpdate.vue?vue&type=template&id=428c4440&scoped=true"
import script from "./passwordUpdate.vue?vue&type=script&lang=js"
export * from "./passwordUpdate.vue?vue&type=script&lang=js"

import "./passwordUpdate.vue?vue&type=style&index=0&id=428c4440&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428c4440"]])

export default __exports__